// import { Spin } from "antd"
import React from "react"
import { BallTriangle } from "react-loader-spinner"
import { useRoutes } from "react-router-dom"
import ROUTER from "."

import InsuranceCertificateRoutesMobile from "src/pages/MAIN"
import HomePage from "src/pages/MAIN/HomePage"
import PartnerRegister from "src/pages/MAIN/PartnerRegister"
import NewsPage from "src/pages/MAIN/NewsPage"
import CertificateByPhoneNumber from "src/pages/MAIN/CertificateByPhoneNumber"
import PurchasePolicyPage from "src/pages/MAIN/PurchasePolicyPage"
import ClaimSupportPage from "src/pages/MAIN/ClaimSupportPage"
import InsuranceGuide from "src/pages/InsuranceCertificateRoutes/InsuranceCertificate/InsuranceGuide"

// ANONYMOUS
const PublicRouters = React.lazy(() => import("src/pages/PublicRouters"))
const SvgViewer = React.lazy(() => import("src/pages/SvgViewer"))
const NotFound = React.lazy(() => import("src/pages/NotFound"))
// Insurance Certificate
const InsuranceCertificateRoutes = React.lazy(() =>
  import("src/pages/InsuranceCertificateRoutes"),
)

const HomeCertificate = React.lazy(() =>
  import("src/pages/InsuranceCertificateRoutes/InsuranceCertificate/Home"),
)
const Certificate = React.lazy(() =>
  import(
    "src/pages/InsuranceCertificateRoutes/InsuranceCertificate/Certificate"
  ),
)
const RenewSeal = React.lazy(() =>
  import("src/pages/InsuranceCertificateRoutes/InsuranceCertificate/Renew"),
)
const OrderSeal = React.lazy(() =>
  import("src/pages/InsuranceCertificateRoutes/InsuranceCertificate/Order"),
)


// ADMIN
const AminRoutes = React.lazy(() => import("src/pages/ADMIN/AminRoutes"))


function LazyLoadingComponent({ children }) {
  return (
    <React.Suspense
      fallback={
        <div className="loading-center" style={{ height: "100vh" }}>
          <BallTriangle
            height={50}
            width={50}
            radius={5}
            color="#01638d"
            ariaLabel="ball-triangle-loading"
            wrapperClass={{}}
            wrapperStyle=""
            visible={true}
          />
        </div>
      }
    >
      {children}
    </React.Suspense>
  )
}

const routes = [
  {
    path: ROUTER.SVG_VIEWER,
    element: (
      <LazyLoadingComponent>
        <SvgViewer />
      </LazyLoadingComponent>
    ),
  },

  // {
  //   path: ROUTER.MAIN_PAGE,
  //   element: (
  //     <LazyLoadingComponent>
  //       <InsuranceCertificateRoutesMobile />
  //     </LazyLoadingComponent>
  //   ),
  // },
  // ADMIN
  {
    element: (
      <LazyLoadingComponent>
        <AminRoutes />
      </LazyLoadingComponent>
    ),
    // Hồ sơ nhân sự
    children: [
    ],
  },

  //  ANONYMOUS
  {
    element: (
      <LazyLoadingComponent>
        <PublicRouters />
      </LazyLoadingComponent>
    ),
    children: [
      // {
      //   path: ROUTER.HOME,
      //   element: (
      //     <LazyLoadingComponent>
      //       <Home />
      //     </LazyLoadingComponent>
      //   ),
      // },
    ],
  },
  {
    element: (
      <LazyLoadingComponent>
        <InsuranceCertificateRoutesMobile />
      </LazyLoadingComponent>
    ),
    children: [
      {
        path: ROUTER.MAIN_PAGE,
        element: (
          <LazyLoadingComponent>
            <HomePage />
          </LazyLoadingComponent>
        ),
      },
      // {
      //   path: ROUTER.HOME_INSURANCE_CERTIFICATE,
      //   element: (
      //     <LazyLoadingComponent>
      //       <HomeCertificate />
      //     </LazyLoadingComponent>
      //   ),
      // },
      {
        path: ROUTER.INSURANCE_CERTIFICATE,
        element: (
          <LazyLoadingComponent>
            <Certificate />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.RENEW_SEAL,
        element: (
          <LazyLoadingComponent>
            <RenewSeal />
          </LazyLoadingComponent>
        ),
      },

      {
        path: ROUTER.ORDER_SEAL,
        element: (
          <LazyLoadingComponent>
            <OrderSeal />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.PARTNER_REGISTER,
        element: (
          <LazyLoadingComponent>
            <PartnerRegister />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.NEWS_PAGE,
        element: (
          <LazyLoadingComponent>
            <NewsPage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.CLAIM_SUPPORT_PAGE,
        element: (
          <LazyLoadingComponent>
            <ClaimSupportPage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.INSURANCE_GUIDE,
        element: (
          <LazyLoadingComponent>
            <InsuranceGuide />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.SEARCH_POLICY_PAGE_PHONE,
        element: (
          <LazyLoadingComponent>
            <CertificateByPhoneNumber />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.PURCHASE_POLICY,
        element: (
          <LazyLoadingComponent>
            <PurchasePolicyPage />
          </LazyLoadingComponent>
        ),
      },
    ],
  },
  {
    path: "*",
    element: (
      <LazyLoadingComponent>
        <NotFound />
      </LazyLoadingComponent>
    ),
  },
]
const AppRouter = () => {
  const renderRouter = useRoutes(routes)
  return renderRouter
}
export default AppRouter
